/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import SVG from "react-inlinesvg";

export function AuthPage() {
    const prevUrl = localStorage.getItem("prevUrl") ? localStorage.getItem("prevUrl") : "";
    const isExtension = prevUrl.includes("/extension");

    return (
        <>
            <div className="d-flex flex-column flex-root">
                {/*begin::Login*/}
                <div
                    className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
                    id="kt_login"
                >
                    {/*begin::Aside*/}
                    <div
                        className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
                        style={{
                            backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-4.jpg")})`,
                        }}
                    >
                        {/*begin: Aside Container*/}
                        <div className="d-flex flex-row-fluid flex-column justify-content-between">
                            {/* start:: Aside header */}
                            <Link
                                to="/"
                                className={`flex-column-auto pb-lg-0 ${isExtension ? "mt-0 pb-5" : "mt-5 pb-10"}`}
                            >
                                {isExtension ? (
                                    <SVG
                                        key="l3rn-tech-logo"
                                        id="l3rn-tech-logo"
                                        src={toAbsoluteUrl("/media/l3rn-tech/L3RNTechWhite.svg")}
                                        height={24}
                                    />
                                ) : (
                                    <img alt="Logo" className="" src={toAbsoluteUrl("/media/logos/logo-dark.png")} />
                                )}
                            </Link>
                            {/* popleads change logo src, deleted className max-h-70px */}
                            {/* end:: Aside header */}

                            {/* start:: Aside content */}
                            {!isExtension && (
                                <div className="flex-column-fluid d-flex flex-column justify-content-center">
                                    <h3 className={`font-size-h1 text-white ${isExtension ? "mb-0" : "mb-5"}`}>
                                        Welcome to Popleads v2
                                    </h3>
                                    <p className="font-weight-lighter text-white opacity-80">
                                        Generate Leads with 1 Click
                                    </p>
                                </div>
                            )}
                            {/* end:: Aside content */}

                            {/* start:: Aside footer for desktop */}
                            <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                                <div className="opacity-70 font-weight-bold	text-white">
                                    &copy; {new Date().getFullYear()} {isExtension ? "L3RN Tech" : "Popleads"}
                                </div>
                                <div className="d-flex">
                                    {!isExtension && (
                                        <a href="mailto:info@popleads.com" className="text-white">
                                            Contact
                                        </a>
                                    )}
                                </div>
                            </div>
                            {/* end:: Aside footer for desktop */}
                        </div>
                        {/*end: Aside Container*/}
                    </div>
                    {/*begin::Aside*/}

                    {/*begin::Content*/}

                    <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
                        {/*begin::Content header*/}
                        {!isExtension && (
                            <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5-login px-10">
                                <span className="font-weight-bold text-dark-50">Don't have an account yet?</span>
                                <a href="mailto:info@popleads.com" className="font-weight-bold ml-2">
                                    Sign Up!
                                </a>
                            </div>
                        )}
                        {/*end::Content header*/}

                        {/* begin::Content body */}
                        <div
                            className={`d-flex flex-column-fluid flex-center mt-lg-0 ${isExtension ? "mt-0" : "mt-30"}`}
                        >
                            <Switch>
                                <ContentRoute path="/auth/login" component={Login} />
                                <ContentRoute path="/auth/registration" component={Registration} />
                                <ContentRoute path="/auth/forgot-password" component={ForgotPassword} />
                                <ContentRoute path="/auth/reset-password" component={ResetPassword} />
                                <Redirect from="/auth" exact={true} to="/auth/login" />
                                <Redirect to="/auth/login" />
                            </Switch>
                        </div>
                        {/*end::Content body*/}

                        {/* begin::Mobile footer */}
                        <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
                            <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                                &copy; {new Date().getFullYear()} {isExtension ? "L3RN Tech" : "Popleads"}
                            </div>
                            <div className="d-flex order-1 order-sm-2 my-2">
                                {!isExtension && (
                                    <a href="mailto:info@popleads.com" className="text-dark-75 text-hover-primary ml-4">
                                        Contact
                                    </a>
                                )}
                            </div>
                        </div>
                        {/* end::Mobile footer */}
                    </div>
                    {/*end::Content*/}
                </div>
                {/*end::Login*/}
            </div>
        </>
    );
}
